import {
  CheckboxUncheckedRegular,
  CheckboxCheckedFilled,
  CheckboxCheckedRegular,
} from '@fluentui/react-icons';
import { Button, Tooltip, makeStyles } from '@fluentui/react-components';
import React, { useCallback, useState } from 'react';
import MilestoneDetails, {
  IMilestoneDetailsProps,
  getMilestoneStatusFormatted,
} from './MilestoneDetails';

const iconMap: Record<string, React.ComponentType> = {
  Checkbox: CheckboxUncheckedRegular,
  BoxCheckmarkSolid: CheckboxCheckedFilled,
  CheckboxFill: CheckboxCheckedRegular,
};

const useStyles = makeStyles({
  iconContainer: {
    minHeight: '24px',
    minWidth: '24px',
    height: '24px',
    width: '24px',
    fontSize: '18px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
  },
  tooltipContent: {
    minWidth: '200px',
  },
});

interface IMilestoneDetailsWrapperProps extends IMilestoneDetailsProps {
  iconName: string;
  color: string;
  milestoneName?: string;
}

const MilestoneDetailsWrapper = (props: IMilestoneDetailsWrapperProps): JSX.Element => {
  const { id, status, iconName, color, milestoneName } = props;
  const [isVisible, setIsVisible] = useState(false);

  const [screenReaderText, setScreenReaderText] = useState(
    `${milestoneName || 'Milestone'} ${getMilestoneStatusFormatted(status)}`,
  );

  const styles = useStyles();
  const IconComponent = iconMap[iconName] || CheckboxUncheckedRegular;
  const handleVisibleChange = useCallback((_e: unknown, data: { visible: boolean }) => {
    setIsVisible(data.visible);
  }, []);

  return (
    <Tooltip
      withArrow
      content={
        <div className={styles.tooltipContent}>
          {isVisible && (
            <MilestoneDetails id={id} status={status} onDataLoaded={setScreenReaderText} />
          )}
        </div>
      }
      relationship="description"
      // DO NOT REMOVE THIS LINE BELOW: it is required to prevent a query being fired off for each milestone in the list on initial render.
      // The query should only be fired when the tooltip is made visible.
      onVisibleChange={handleVisibleChange}
    >
      <Button
        appearance="transparent"
        className={styles.iconContainer}
        style={{ color }}
        icon={<IconComponent aria-hidden />}
        aria-label={screenReaderText}
      />
    </Tooltip>
  );
};

export default MilestoneDetailsWrapper;
